"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyScheduleInput = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.DailyScheduleInput = typebox_1.Type.Object({
    driverProfileID: typebox_1.Type.String({ format: 'uuid' }),
    date: typebox_1.Type.Object({
        year: typebox_1.Type.Number({ min: 2000, max: 2100 }),
        month: typebox_1.Type.Number({ min: 1, max: 12 }),
        day: typebox_1.Type.Number({ min: 1, max: 31 }),
    }),
    entries: typebox_1.Type.Array(typebox_1.Type.Object({
        type: typebox_1.Type.String(),
        orderID: typebox_1.Type.String({ format: 'uuid' }),
    })),
});
//# sourceMappingURL=daily-schedule-input.js.map